import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const SvgContainer = styled.svg`
  width: ${props => (props.size ? props.size + "px" : "19px")};
  height: ${props => (props.size ? props.size + "px" : "19px")};
  margin-right: -1px;
  margin-top: -8px;
  path {
    fill: ${props => (props.color ? props.color : Variables.colors.black)};
  }
`;
